import { BRAND_COLORS } from "./brandColors";

export const TEMPERATURE_COLOR_PALETTE = [
  BRAND_COLORS.blueDark,
  BRAND_COLORS.orange,
  BRAND_COLORS.blueLight,
  BRAND_COLORS.black,
  "#3C8C88",
  "#E6975C",
  "#5FA9B8",
  "#5B5454",
  "#7CB7A8",
  "#C96E2C",
] as const;

export const DEFAULT_TEMPERATURE_RANGES = [
  { label: "2 - 8 °C", min: 2, max: 8 },
  { label: "15 - 25 °C", min: 15, max: 25 },
  { label: "Toutes les températures", min: Number.NEGATIVE_INFINITY, max: Number.POSITIVE_INFINITY },
] as const;

export const SAFE_TEMPERATURE_RANGE = { min: 2, max: 8 } as const;
